var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Markdown"},[_c('Editor',{ref:"editor",attrs:{"configs":_vm.configs,"modelValue":_vm.valueFormatted},on:{"update:modelValue":_vm.emitValue}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }